/**
 * Current calendar quarter from `date` — footer availability label.
 * Q1 Jan–Mar · Q2 Apr–Jun · Q3 Jul–Sep · Q4 Oct–Dec
 */
export function getAvailabilityQuarter(date = new Date()) {
  const month = date.getMonth(); // 0–11
  const year = date.getFullYear();
  const quarter = Math.floor(month / 3) + 1;

  return { quarter, year };
}

export function formatAvailabilityLabel(date = new Date()) {
  const { quarter, year } = getAvailabilityQuarter(date);
  return `Available — Q${quarter} / ${year}`;
}

/** Local midnight at the start of the next calendar quarter. */
function getNextQuarterStart(date = new Date()) {
  const year = date.getFullYear();
  const nextStartMonth = (Math.floor(date.getMonth() / 3) + 1) * 3;

  if (nextStartMonth >= 12) {
    return new Date(year + 1, 0, 1, 0, 0, 0, 0);
  }

  return new Date(year, nextStartMonth, 1, 0, 0, 0, 0);
}

export function getMsUntilNextQuarterStart(date = new Date()) {
  return Math.max(1, getNextQuarterStart(date).getTime() - date.getTime());
}
